export default [
    'Banco de Chile',
    'Banco Estado',
    'Banco Internacional',
    'Scotiabank Chile',
    'Banco de Credito e Inversiones',
    'Corpbanca',
    'Banco Bice',
    'HSBC Bank (CHILE)',
    'Banco Santander-Chile',
    'Banco Itaú Chile',
    'Banco Security',
    'Banco Falabella',
    'Deutsche Bank',
    'Banco Ripley',
    'RaboBank Chile',
    'Banco Consorcio',
    'Banco Penta',
    'Banco Paris',
    'Banco Bilbao Vizcaya Arge',
    'Banco Desarrollo'
]
